const mapMode = {
  CLEAR: 'clear',
  MARKER: 'marker',
  POLYGON: 'polygon',
  SAVED_LOCATION: 'saved-location',
}

export default mapMode
